import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Table, Input, Row, Col, message, Spin, Tooltip, Tag } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import ErrorWrapper from '../../../lib/error_wrapper';
import { WifiTetheringOutlined, FlipOutlined, Label } from '@material-ui/icons';
const queryString = require('query-string');

const data_type_schema = [
    {
        index: "name",
        name: "Name",
        type: 'text',
        // help_text:"Hello i am help text"
    }, {
        index: 'description',
        name: "Description",
        type: 'textarea'
    },
    {
        index: "debit_balance",
        name: "Add Debit Balance",
        type: 'bool',
        help_text: "Debit amount should be added or substracted? True to Add."
    },
    {
        index: 'transfer_expression',
        name: "Transfer Expression",
        type: 'text',
        help_text: "Help Content"
    },
    {
        index: 'fields_config',
        name: "Field Config",
        type: 'json',
        default:[]
    }

]
const data_type_cols = ({ onEditPressed, onMirrorPressed ,group_id}) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        className: 'word-break bold-cell',
        width:200
    }, {
        title: "Description",
        dataIndex: "description",
        key: 'description',
        className:'word-break',
    }, 
    {
        width:80
    },
    {
        title: "Debit Balance",
        dataIndex: 'debit_balance',
        key: 'debit_balance',
        width: 80,
        render: (debit_balance) => debit_balance ? "Add" : "Subtract"
    },
    {
        width:80
    },
    {
        title: "Transfer Expression",
        dataIndex: 'transfer_expression',
        key: 'transfer_expression',
    },
    {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width: 220,
        render: (id, data) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap'
            }}>
                 <Link to={`/settings/groups/${group_id}/datatype/${id}/edit`} >
                <Button
                    type='link'
                    style={{ padding: 0 }}
                    // onClick={() => {
                    //     typeof onEditPressed === 'function' && onEditPressed(id, data);
                    // }}
                    >Edit</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/services`}>
                    <Button style={{ padding: 0 }} type='link'>Services</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/classifiers`}>
                    <Button style={{ padding: 0 }} type='link'>Classifiers</Button>
                </Link>
                {/* <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/pipelines`}>
                    <Button style={{ padding: 0 }} type='link'>Pipelines</Button>
                </Link> */}
                {/* <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/balances`}>
                    <Button style={{ padding: 0 }} type='link'>Balances</Button>
                </Link> */}
                <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/labels`}>
                    <Button style={{ padding: 0 }} type='link'>Labels</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${id}/actions`}>
                    <Button style={{ padding: 0 }} type='link'>Actions</Button>
                </Link>
                <Divider type='vertical' />
                <Button style={{ padding: 0 }} type='link' onClick={() => {
                    typeof onMirrorPressed === 'function' && onMirrorPressed(id)
                }}>Link To</Button>
            </div>
        }
    }
];

class DataTypeList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {
                per_page: 10,
                page: 1
            },
            form_data: {},
            edit_id: null,
            form_visibility: false,
            selected_ids: [],
            all_selected: false,
            loading: true,
            group_obj: {},
            mirroring_id: null
        };

        this.group_id = props.match.params.group_id;

        this.detail_group = RESTExecutor.detail().config({
            label: 'detail'
        }).callbacks((success) => {
            this.setState({ loading: false, group_obj: success.result })
            this.list_datatype.config({
                params: {
                    ...this.state.filter_query,
                    group_id: this.group_id
                }
            }).execute();
        }, (error) => {
            this.setState({ loading: false })
        }).connect(props.domains.groups);

        this.mirror_datatype_to = RESTExecutor.post().config({
            label: 'mirror_to'
        }).callbacks((success) => {
            message.success("Datatype successfully mirrored");
            this.setState({
                mirroring_id: null
            })
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.datatype);

        this.list_datatype = RESTExecutor
            .list()
            .config({
                label: 'data_types',
                params: {
                    ...this.state.filter_query
                }
            })
            .connect(props.domains.datatype);

        this.post_datatype = RESTExecutor.post().config({
            label: 'data_types'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_datatype.execute()
            })
            .connect(props.domains.datatype);

        this.patch_datatype = RESTExecutor.patch().config({
            label: 'data_types_detail'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_datatype.execute()
            })
            .connect(props.domains.datatype);


        this.export_data = RESTExecutor.post().config({
            label: 'export'
        }).callbacks((success) => {
            this.setState({ selected_ids: [], all_selected: false })
            // console.log("download url",success)
            window.open(success.result.url, '_blank');

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.settings);


        this.delay_search = new NetworkDelaySearch();
    };

    handlePostPatch = (data) => {

        if (this.state.edit_id) {
            this.patch_datatype.forId(this.state.edit_id).execute({
                ...data,
                group_id: this.group_id
            });
        } else {
            this.post_datatype.execute({
                ...data,
                group_id: this.group_id
            });
        }
    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const { filter_query, selected_ids, group_obj, loading, mirroring_id } = this.state;
        let list_datatype_resp = this
            .list_datatype
            .response();

        if (loading) {
            return <center><Spin /></center>
        }

        let detail_group_resp = this.detail_group.response()
        let export_data_resp = this.export_data.response();

        let post_datatype_resp = this.post_datatype.response();
        let patch_datatype_resp = this.patch_datatype.response();
        let mirror_datatype_to_resp = this.mirror_datatype_to.response()

        let rowsData = (list_datatype_resp.result && list_datatype_resp.result.rows) || [];
        let rowsMeta = list_datatype_resp.meta || {};

        return (
            <div>
                <ErrorWrapper error={detail_group_resp}
                    onReload={() => {
                        this.setState({ loading: true })
                        this.detail_group.forId(this.group_id).execute()
                    }}
                >


                    <BasicHeader
                        title={group_obj.name}
                        titleType="Group"
                        subtitle="Datatypes"
                        // titleType

                        right={[
                            <Link to={`/settings/groups/${this.group_id}/datatype/add`} >
                            <TransparentButton
                                label="Add New"
                                className='cta-primary'
                                hint="Add New Datatype"
                                // onClick={() => {
                                //     this.setState({
                                //         edit_id: null,
                                //         form_data: {},
                                //         form_visibility: true
                                //     })
                                // }}

                            /></Link>,
                            <Link to={`/settings/groups/${this.group_id}/source`} >
                                <TransparentButton
                                    label="Sources"
                                    icon={<WifiTetheringOutlined />}
                                    hint="View Sources"
                                />
                            </Link>,
                            <Link to={`/settings/groups/${this.group_id}/reconcilers`} >
                                <TransparentButton
                                    label="Processors"
                                    icon={<FlipOutlined />}
                                    hint="View Reconcilers"
                                />
                            </Link>,
                            <Link to={`/settings/groups/${this.group_id}/labels`} >
                                <TransparentButton
                                    label="Labels"
                                    icon={<Label />}
                                    hint="View Labels"
                                /></Link>,
                        <TransparentButton
                                    label="Export"
                                    hint="Export Selected Datatype"
                                    disabled={selected_ids.length == 0}
                                    onClick={() => {
                                        this.export_data.execute({
                                            data_types: this.state.all_selected ? true : selected_ids
                                        });
                                    }}

                                />
                    ]}

                />
                <div className='filter-card'>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        flexWrap: 'nowrap',
                                        paddingTop: 4, paddingBottom: 12
                                    }}>
                                        <Input.Search
                                            autoFocus
                                            placeholder="Search For"
                                            style={{
                                            }}
                                            value={filter_query.query}
                                            onChange={(e) => {
                                                this.stateUpdater({
                                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                                        this.delay_search.onSearch(() => {
                                                            this.props.history.push({
                                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                            })
                                                        })
                                                    }
                                                })
                                            }}
                                        />
                                    </div>
                                    {/* {selected_ids.length != 0 && selected_ids.length == rowsMeta.data_count &&
                                rowsMeta.data_count != rowsMeta.total_count
                                && <React.Fragment>
                                    <Row type='flex' justify='center' align='middle' style={{
                                        paddingTop: 6
                                    }}>

                                        {!this.state.all_selected ? <React.Fragment>
                                            <strong>All {selected_ids.length} Datatype on this page are selected.</strong>
                                            <Button type='link' onClick={() => {
                                                this.setState({ all_selected: true })
                                            }}>Select all {rowsMeta.total_count} Datatype</Button>
                                        </React.Fragment> : <React.Fragment>
                                                <strong>All {rowsMeta.total_count} Datatype are selected.</strong>
                                                <Button type='link' onClick={() => {
                                                    this.setState({ all_selected: false })
                                                }}>Clear Selection</Button>
                                            </React.Fragment>}
                                    </Row>

                                </React.Fragment>} */}
                                </div>
                                <ErrorWrapper
                                    error={list_datatype_resp}
                                    onReload={() => {
                                        this.list_datatype.config({
                                            params: {
                                                ...filter_query,
                                                group_id: this.group_id
                                            }
                                        }).execute()
                                    }}
                                >

                                    <div
                                        className='default-card'
                                        style={{
                                            padding: 0
                                        }}>

                                        <PopUpForm
                                            title={"Select Group"}
                                            stringyfy={false}
                                            show_title_only
                                            forCreate={true}
                                            initialData={this.state.form_data}
                                            fields={[
                                                { index: 'group_id', type: 'networkselect', name: "Group", url: `/groups` },

                                            ]}
                                            open={mirroring_id != null}
                                            networkState={mirror_datatype_to_resp}
                                            onClose={() => this.setState({ mirroring_id: null })}
                                            onSubmit={(data) => {
                                                console.log("DATA", data);
                                                this.mirror_datatype_to.forId(mirroring_id).execute(data);
                                                // this.handlePostPatch(data);
                                            }} />
                                        <PopUpForm
                                            title={"Datatype"}
                                            width="99%"
                                            forCreate={this.state.edit_id
                                                ? false
                                                : true}
                                            initialData={this.state.form_data}
                                            fields={data_type_schema}
                                            open={this.state.form_visibility}
                                            networkState={this.state.edit_id
                                                ? patch_datatype_resp
                                                : post_datatype_resp}
                                            onClose={() => this.setState({ form_visibility: false })}
                                            onSubmit={(data) => {
                                                console.log("DATA", data);
                                                this.handlePostPatch(data);
                                            }} />

                                        <Table // rowClassName='hand-cursor'
                                            className='main-table'
                                            loading={list_datatype_resp.fetching || export_data_resp.fetching}
                                            size='small'
                                            rowSelection={{
                                                onChange: (selected_ids) => {
                                                    if (selected_ids.length != rowsMeta.data_count) {
                                                        this.setState({ all_selected: false })
                                                    }
                                                    this.setState({ selected_ids })
                                                },
                                                selectedRowKeys: selected_ids
                                            }}
                                            scroll={{ x: true }}
                                            pagination={{
                                                simple: false,
                                                position: 'bottom',
                                                onChange: (current, size) => {
                                                    this.props.history.push({
                                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                                    })
                                                },
                                                defaultCurrent: 1,
                                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                                pageSize: (rowsMeta && rowsMeta.requested_count),
                                                total: (rowsMeta && rowsMeta.total_count),
                                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                                            }}
                                            rowKey={(record) => record.id} columns={data_type_cols({
                                                onEditPressed: (id, data) => {
                                                    this.setState({
                                                        edit_id: id,
                                                        form_data: data,
                                                        form_visibility: true
                                                    })

                                                },
                                                onMirrorPressed: (id, data) => {
                                                    this.setState({ mirroring_id: id })
                                                },
                                                group_id:this.group_id
                                            })} dataSource={rowsData} />


                                    </div>
                                </ErrorWrapper>     

                </ErrorWrapper>
            </div>
        );
    }

    componentDidMount() {


                        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
                        filter_query: {
                        per_page: 100,
                page: 1,
                ...new_filter_query,
                group_id:this.group_id
            }
        }, () => {
                        this.detail_group.forId(this.group_id).execute()
                    })
    }

    componentWillReceiveProps(nextProps) {
        var oldgroup_id = this.props.match.params.group_id;
        var newgroup_id = nextProps.match.params.group_id;


        if (oldgroup_id !== newgroup_id || (
          this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
                        this.group_id = newgroup_id;
          const parsed = queryString.parse(nextProps.location.search);
          this.setState({
                        filter_query: {
                        per_page: 100,
              page: 1,
              ...parsed,
              group_id:this.group_id
            },
          }, () => {
            if (oldgroup_id !== newgroup_id) {
                        this.setState({
                            loading: true
                        }, () => {
                            this.detail_group.forId(this.group_id).execute()
                        })
                    } else {
                        this.list_datatype.forId(this.group_id).config({
                            params: {
                                ...this.state.filter_query
                            }
                        }).execute()
                    }
          })
    
        }
      }



}

export default withDomains(DataTypeList, "datatype", "settings","groups");

